import React from "react";

const DownloadIcon = (props) => {
    const {} = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 10 10"
        >
            <title>Asset 9</title>
            <g id="Layer_2" data-name="Layer 2">
                <g id="info">
                    <path d="M9.5,6a.5.5,0,0,0-.5.5V9H1V6.5a.5.5,0,0,0-1,0V10H10V6.5A.5.5,0,0,0,9.5,6Z"/>
                    <path d="M5,7.21,7.35,4.85a.5.5,0,0,0-.71-.71L5.5,5.29V0h-1V5.29L3.35,4.15a.5.5,0,0,0-.71.71Z"/>
                </g>
            </g>
        </svg>
    )
};

export default DownloadIcon;